import { useState } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import ListItemWithIcon from '@r1-frontend/ui-react/components/List/WithIcon';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import { Forward, VideoAdd, VideoVertical, VoiceSquare } from '@r1-frontend/ui-react/components/svg/media';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const DecoderInfo = (): JSX.Element => {
    const [isOpen, changePopupState] = useState(false);

    const handleClosePopup = () => {
        changePopupState(false);
    };

    const handleOpenPopup = () => {
        changePopupState(true);
    };

    return (
        <>
            <Paragraph4>
                Она нужна, чтобы смотреть ТВ-каналы и&nbsp;подписки из&nbsp;своего тарифа. {' '}
                <ControlElement Icon={InfoCircleFlip} onClick={handleOpenPopup}>Все преимущества приставки</ControlElement>
            </Paragraph4>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <ListContainer $size={24}>
                        <ListContainer $size={16} $direction={'column'} $wrap={'nowrap'}>
                            <H3 $withIndent={false} style={{ paddingRight: 45 }}>ТВ-приставка Movix&nbsp;&mdash;&nbsp;это:</H3>

                            <ListItemWithIcon Icon={VideoVertical} textColor={COLORS.TextPrimary}>Тысячи игр и&nbsp;приложений для Android&nbsp;TV</ListItemWithIcon>
                            <ListItemWithIcon Icon={Forward} textColor={COLORS.TextPrimary}>Цифровое ТВ&nbsp;нового поколения с&nbsp;управлением прямым эфиром</ListItemWithIcon>
                            <ListItemWithIcon Icon={VideoAdd} textColor={COLORS.TextPrimary}>Кино и&nbsp;сериалы из&nbsp;разных подписок в&nbsp;одном каталоге</ListItemWithIcon>
                            <ListItemWithIcon Icon={VoiceSquare} textColor={COLORS.TextPrimary}>Удобный голосовой поиск и&nbsp;родительский контроль</ListItemWithIcon>
                        </ListContainer>

                        <ButtonGroup>
                            <Button bType={'action'} size={'large'} onClick={handleClosePopup}>Закрыть</Button>
                        </ButtonGroup>
                    </ListContainer>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};
